/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: OuterAgency DataTable
 * Description: OuterAgency DataTable
 * Date: 15/03/2022
 */

import React, { useCallback, useEffect } from 'react';
import { Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import useDataTable from '../../../hooks/useDataTable';
import SweetAlertService from '../../../services/SweetAlertService';
import UrlService from '../../../services/UrlService';
import { useOuterAgency } from './ContextAPI';
import FormInfo from './FormInfo';

export default function DataTable() {
    const { outerAgencies, getAllData } = useOuterAgency();
    const { deleteSwal } = SweetAlertService();

    const dataList = useCallback(() => {
        getAllData();
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    const deleteHandler = (row) => {
        deleteSwal({
            id: row.id,
            url: UrlService.deleteOuterAgencyUrl(),
            refreshList: getAllData,
            beforeTitle: 'Are you sure?',
            beforeText: "You won't be able to revert this!",
            afterTitle: 'Deleted!',
            afterText: 'Your file has been deleted.',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
    };

    const columns = [
        {
            name: 'Code',
            selector: (row) => row.code_no,
            sortable: true,
        },
        {
            name: 'Name',
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: 'Address',
            selector: (row) => row.address,
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row) => row.email,
            sortable: true,
        },

        {
            name: 'Mobile',
            selector: (row) => row.phone,
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => row.status,
            cell: (row) =>
                row.status == 1 ? (
                    <Badge className="badgeActive" bg="success">
                        Active
                    </Badge>
                ) : (
                    <Badge className="badgeInactive" bg="success">
                        Inactive
                    </Badge>
                ),
        },
        {
            name: 'Action',
            selector: (row) => row.action,
            cell: (row) => (
                <>
                    {/* <button data-id={row.id} type="button" className="btn btn-light actionBtn">
                        {layout}
                    </button> */}

                    <FormInfo editData={row} />

                    <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-del-${row.id}`}>Delete</Tooltip>}>
                        <Button
                            onClick={() => {
                                deleteHandler(row);
                            }}
                            type="button"
                            className="btn btn-light actionBtn"
                        >
                            <i className="fas fa-trash-alt" />
                        </Button>
                    </OverlayTrigger>
                </>
            ),
        },
    ];
    const search_column = {
        code_no: 'Code No',
        name: 'Name',
        email: 'Email',
        phone: 'Mobile/Phone',
        address: 'Address',
    };
    return useDataTable({ columns, data: outerAgencies, search_column });
}
